import { Themed } from "@components/atoms/Themed"
import { DrawingGenerator } from "@components/generator/DrawingGenerator"
import { InteractiveGenerator } from "@components/generator/InteractiveGenerator"
import { ScrollReveal } from "@components/motion/Transitioned"
import { DEFAULT_SETTINGS, GeneratorSettings } from "@generator/src"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useMemo } from "react"

export const meta: BlockMeta = {
  title: "Text and Flowgram",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/text-and-flowgram", (props) => {
  const theme = props.pageTheme || "none"
  const inverted = ["black", "brick", "olive", "navy", "red", "bark"].includes(theme)

  const settings = useMemo(() => {
    const settings: GeneratorSettings = {
      ...DEFAULT_SETTINGS,
      cols: 8,
      rows: 8,
      density: 8,
      seed: Math.random(),
      lineOffset: 0,
      lineWidth: 2,
      scheme: "neutral",
      invertScheme: inverted,
      outline: true,
      autoWarpOn: false,
      mouseOn: false,
      exportPadding: 0,
      renderMode: "draw",
    }
    return settings
  }, [])

  return (
    <ScrollReveal>
      <Themed theme={theme} className="w-full my-10 py-7 themed-fg themed-bg">
        <div className="w-grid mx-auto grid grid-cols-1 md:grid-cols-2 gap-7 items-center justify-center">
          <div
            className="flex flex-col aspect-square w-full border-2 rounded-xl border-current p-7 items-start justify-center"
            data-transition="scale"
          >
            <EditableText
              as="p"
              store="subtitle"
              className="type-label-s-caps"
              placeholder="Enter an optional subtitle"
              data-transition="fade-up"
            />
            <EditableText
              as="h2"
              store="title"
              className="mt-4 type-title-m text-balance"
              placeholder="Enter a title"
              data-transition="fade-up"
            />
            <div
              className="w-full flex flex-col gap-4 mt-7 md:mt-5 [&_p]:!w-full [&_p]:!mt-0 [&_p]:!px-0 [&_.wysiwyg-text]:!w-full [&_.wysiwyg-text]:!px-0 [&_.wysiwyg-text]:!mt-0 [&_ul]:!gap-2 [&_ol]:!gap-2 [&_li]:!ml-4"
              data-transition="scale"
            >
              <InnerBlocks
                allowedBlocks={["#inline", "content/buttons"]}
                template={[["core/paragraph", { placeholder: "Enter some text" }]]}
                orientation="vertical"
                adminClassName="w-full flex flex-col gap-4"
              />
            </div>
          </div>
          <div className="w-full aspect-square flex items-center justify-center">
            <DrawingGenerator settings={settings} />
          </div>
        </div>
      </Themed>
    </ScrollReveal>
  )
})
